class WholesaleModal extends HTMLElement {
  constructor() {
    super();
    
    this.wholesaleFooterLink = document.getElementById('wholesaleLoginFooterLink');
    if (this.wholesaleFooterLink) {      
      this.wholesaleFooterLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.openModal();
      });
    }

    this.modalBackground = this.getElementsByClassName('bg')[0];
    this.closeButton = this.querySelector('button');

    if (this.closeButton)
    this.closeButton.addEventListener('click', (e) => {
      this.close(); 
    })

    this.modalBackground.addEventListener('click', (e) => {
      console.log(e.target.classList);
      if (e.target.className == 'wholesale-link') {
        console.log('Link was clicked.');
        e.preventDefault();
        console.log(this.wholesaleFooterLink.href);
        window.open(this.wholesaleFooterLink.href, '_blank');
      }
      
      if(e.target.className === 'bg bg-visible') {
        this.close();
      }
    })

    document.addEventListener(
      'keyup',
      (e) => {
        e.code.toUpperCase() === 'ESCAPE' && this.close();
      }
    );
  }

  openModal() {
    this.style.visibility = null;
    this.classList.add('hurricane-modal-visible');
    setTimeout(() => {
      this.modalBackground.classList.add('bg-visible');

    }, 100);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    console.log(event.target);
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  close(focusToggle = true) {
    console.log('goodbye hurricane');
    this.classList.remove('hurricane-modal-visible');
  }

}

customElements.define('wholesale-modal', WholesaleModal);
